import CmgKeysSettings from "./setting/CmgKeysSettings"
import SilverRupeesSettings from "./setting/SilverRupeeSettings"
import KeysanitySettings from "./setting/KeysanitySettings"
import AdultTradeSettings from "./setting/AdultTradeSettings"
import BridgeSettings from "./setting/BridgeSettings"
import TrialsSettings from "./setting/TrialsSettings"
import OpenDekuSettings from "./setting/OpenDekuSettings"
import OpenKakaricoGateSettings from "./setting/OpenKakaricoGateSettings"
import OpenDoTSettings from "./setting/OpenDoTSettings"
import OpenFountainSettings from "./setting/OpenFountainSettings"
import OpenFortressSettings from "./setting/OpenFortressSettings"
import TriforceHuntSettings from "./setting/TriforceHuntSettings"
import InterriorShuffleSettings from "./setting/InterriorShuffleSettings"
import OverworldShuffleSettings from "./setting/OverworldShuffleSettings"
import { Box } from "@mui/material"
import GrottoShuffleSettings from "./setting/GrottoShuffleSettings"
import DungeonsShuffleSettings from "./setting/DungeonShuffleSettings"
import BossShuffleSettings from "./setting/BossShuffleSettings"
import MQSettings from "./setting/MqSettings"
import ShopsanitySettings from "./setting/ShopsanitySettings"
import GbkSettings from "./setting/GbkSettings"
import WarpSongSettings from "./setting/WarpSongSettings"
import TokensanitySettings from "./setting/Tokensanity"
import OwlDropSettings from "./setting/OwlDropSettings"
import ScrubsanitySettings from "./setting/ScrubsanitySettings"
import CowsanitySettings from "./setting/CowsanitySettings"
import SongsanitySettings from "./setting/Songsanity"
import KsSettings from "./setting/KsSettings"
import OcarinaSettings from "./setting/OcarinaSettings"
import GerudoCardSettings from "./setting/GerudoCardSettings"
import BeansSettings from "./setting/BeansSettings"
import ExpensiveMerchantsSettings from "./setting/ExpensiveMerchantSettings"
import FrogsSettings from "./setting/FrogsSettings"
import MapCompassSettings from "./setting/MapCompassSettings"
import MapCompassInfoSettings from "./setting/MapCompassInfoSettings"
import BksanitySettings from "./setting/Bksanity"
import BeatableOnlySettings from "./setting/BeatableOnlySettings"
import EscapeSequenceSettings from "./setting/EscapeSequenceSettings"
import EponaRaceSettings from "./setting/EponaRaceSettings"
import FreeScarecrowSettings from "./setting/FreeScarecrowSettings"
import CompleteMaskQuestSettings from "./setting/CompleteMaskQuestSettings"
import PlantedBeansSettings from "./setting/PlantedBeansSettings"
import CuccosSettings from "./setting/CuccosSettings"
import BigPoesSettings from "./setting/BigPoesSettings"
import CamcSettings from "./setting/CamcSettings"
import BlueFireArrowSettings from "./setting/BlueFireArrowsSettings"
import DamageSettings from "./setting/DamageSettings"
import ObkoSettings from "./setting/ObkoSettings"
import ItemPoolSettings from "./setting/ItemPoolSettings"
import IceTrapSettings from "./setting/IceTrapSettings"
import StartConsumableSettings from "./setting/StartConsumableSettings"
import StartRupeesSettings from "./setting/StartRupeesSettings"
import RutoF1Settings from "./setting/RutoF1Settings"



const S6SettingsTracker = () => {

    return <Box display="flex" flexDirection={"column"} flexWrap={"wrap"} maxHeight={600}>
        <BridgeSettings />
        <GbkSettings />
        <TriforceHuntSettings />
        <CmgKeysSettings />
        <SilverRupeesSettings />
        <KeysanitySettings />
        <BksanitySettings />
        <AdultTradeSettings />
        <OpenDekuSettings />
        <OpenKakaricoGateSettings />
        <OpenDoTSettings />
        <OpenFountainSettings />
        <OpenFortressSettings />
        <InterriorShuffleSettings />
        <OverworldShuffleSettings />
        <GrottoShuffleSettings />
        <DungeonsShuffleSettings />
        <BossShuffleSettings />
        <OwlDropSettings />
        <WarpSongSettings />
        <TokensanitySettings />
        <ScrubsanitySettings />
        <CowsanitySettings />
        <SongsanitySettings />
        <KsSettings />
        <OcarinaSettings />
        <GerudoCardSettings />
        <BeansSettings />
        <ExpensiveMerchantsSettings />
        <FrogsSettings />
        <MapCompassSettings />
        <MapCompassInfoSettings />
        <BeatableOnlySettings />
        <EscapeSequenceSettings />
        <EponaRaceSettings />
        <FreeScarecrowSettings />
        <CompleteMaskQuestSettings />
        <PlantedBeansSettings />
        <CuccosSettings />
        <BigPoesSettings />
        <CamcSettings />
        <BlueFireArrowSettings />
        <DamageSettings />
        <ObkoSettings />
        <ItemPoolSettings />
        <IceTrapSettings />
        <StartConsumableSettings />
        <StartRupeesSettings />
        <RutoF1Settings />
        <MQSettings />
        <ShopsanitySettings />
        <TrialsSettings />
    </Box>
}

export default S6SettingsTracker






